var exports = {
  "item": "x7f9a0e16--018c91--item",
  "content": "x7f9a0e16--018c91--content",
  "question": "x7f9a0e16--018c91--question",
  "answer": "x7f9a0e16--018c91--answer",
  "icon": "x7f9a0e16--018c91--icon",
};

module.exports = exports;
